import styled, { keyframes } from "styled-components";

import { colorsPalettes, elevation } from "@similarweb/styles";
import { Badge } from "@similarweb/ui-components";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

import { useTranslation } from "pro-features/components/WithTranslation";
import { mnpNavigation } from "app/pages/digital-marketing/monitor-and-protect/app/navigation";
import { CroppedImage } from "app/pages/digital-marketing/monitor-and-protect/shared/components/cropped-image/cropped-image";
import { AssetsService } from "app/services/AssetsService";

const fadeIn = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;

const AnimatedContainer = styled.div`
    animation: ${fadeIn} 0.5s ease-in-out 1s both;
    width: 100%;
    max-width: 804px;
    margin: 40px auto;
`;

interface IDemoLink {
    campaignId?: string;
}

export const DemoLink = ({ campaignId }: IDemoLink) => {
    const translate = useTranslation();

    return (
        <AnimatedContainer>
            <Flex
                as="a"
                outline="none"
                href={mnpNavigation.overview.getLink({ campaignId })}
                boxSizing="border-box"
                cursor="pointer"
                boxShadow={elevation.Z2}
                padding="32px 24px"
                justifyContent="space-between"
                alignItems="center"
                background={colorsPalettes.carbon[0]}
                borderRadius="3px"
            >
                <Stack>
                    <Text
                        fontVariant="subtitle1"
                        color={colorsPalettes.carbon[300]}
                    >
                        {translate("monitor_and_protect.features.homepage.demo_link.title")}
                    </Text>
                    <Text
                        fontVariant="subtitle1"
                        color={colorsPalettes.carbon[300]}
                    >
                        {translate("monitor_and_protect.features.homepage.demo_link.subtitle")}
                    </Text>
                </Stack>
                <Flex
                    alignItems="center"
                    gap="8px"
                >
                    <CroppedImage
                        alt={translate("monitor_and_protect.features.homepage.demo_link.logo_alt")}
                        src={AssetsService.assetUrl("/images/monitor-and-protect/intuit-demo-logo.png")}
                    />
                    <Badge
                        type={"demo"}
                        shouldTransformTextToUpperCase={true}
                    >
                        {translate("monitor_and_protect.features.homepage.demo_link.badge")}
                    </Badge>
                </Flex>
            </Flex>
        </AnimatedContainer>
    );
};
